(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdf-consent')) {
    customElements.define('pdf-consent', class extends HTMLElement {
      connectedCallback() {
        this.ids = (this.dataset.pdfVariants || '').split(',').filter(Boolean);
        this.wrap = this.querySelector('.pdf-consent');
        this.box = this.querySelector('.pdf-consent__box');
        this.err = this.querySelector('.pdf-consent__error');
        const btn = this.querySelector('button');
        this.form = (btn && btn.form) || this.closest('form');

        if (this.form && !this.form.contains(this.box)) {
          if (!this.form.id) this.form.id = 'pdf-form-' + Math.random().toString(36).slice(2);
          this.box.setAttribute('form', this.form.id);
        }

        this.update = () => setTimeout(() => this.refresh(), 80);
        document.addEventListener('variant:update', this.update);
        document.addEventListener('change', this.update);

        this.box.addEventListener('change', () => {
          if (this.box.checked) this.showError(false);
        });

        this.onClick = (e) => {
          const button = this.querySelector('button');
          if (!button || !button.contains(e.target)) return;
          this.refresh();
          if (!this.box.disabled && !this.box.checked) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.showError(true);
            this.wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.box.focus({ preventScroll: true });
          }
        };
        this.addEventListener('click', this.onClick, true);

        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.update);
        document.removeEventListener('change', this.update);
      }

      isPdf() {
        if (!this.form) return !this.wrap.hidden;
        const id = new FormData(this.form).get('id');
        return id ? this.ids.includes(String(id)) : !this.wrap.hidden;
      }

      refresh() {
        const pdf = this.isPdf();
        this.wrap.hidden = !pdf;
        this.box.disabled = !pdf;
        if (!pdf) this.showError(false);
      }

      showError(show) {
        this.err.hidden = !show;
        this.wrap.classList.toggle('pdf-consent--error', show);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
